import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import '../styles/carousel.css';

import { openPage } from './pageDisplay'; 

const IMAGE_FILE_TYPES = ['jpg', 'jpeg', 'png', 'gif'];

const getFileType = (url) => {
  return url.split('.').pop().toLowerCase();
};

const isYouTubeLink = (url) => {
  return url.includes('youtu.be') || url.includes('youtube.com');
};

const getYoutubeThumbnail = (url) => {
  const videoId = url.split('/').pop();
  return `https://img.youtube.com/vi/${videoId}/0.jpg`;
};

const PageSwiper = ({ images }) => {
  // Determine how many slides to show based on the number of images
  const slidesToShow = Math.min(5, images.length);
  const isCentered = images.length > 1;

  return (
    <>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={isCentered}
        slidesPerView={slidesToShow}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        loop={images.length > 1} // Loop only if more than one image
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[EffectCoverflow, Navigation, Pagination]}
        className="mySwiper"
      >
        {images.map((item, index) => (
          <SwiperSlide key={index}>
            {IMAGE_FILE_TYPES.includes(getFileType(item.url)) ? (
              <span className="img-text" onClick={() => openPage(item.url, 'image')}>
                <img src={item.url} alt={item.title} className="thumbnail" />
              </span>
            ) : getFileType(item.url) === 'mp4' ? (
              <span className="img-text" onClick={() => openPage(item.url, 'video')}>
                <video muted autoPlay loop className="full-size-video">
                  <source src={item.url} type="video/mp4" />
                </video>
              </span>
            ) : isYouTubeLink(item.url) ? (
              <span className="img-text" onClick={() => openPage(item.url, 'youtube')}>
                  <img src={getYoutubeThumbnail(item.url)} alt={item.title} className="thumbnail" />
              </span>
            ) : (
              <div className="non-image-placeholder">Non-image file</div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default PageSwiper;
